import project1 from "../assets/projects/project-1.png";
import project2 from "../assets/projects/project-2.png"
export const HERO_CONTENT = `I'm Arijit Ghosh, a passionate B.Tech IT student at Haldia Institute of Technology with expertise in full-stack web development using the MERN stack. I thrive on building innovative projects, solving complex problems, and contributing to open-source communities. Dedicated to continuous learning, I aim to excel in software engineering and make a meaningful impact in the tech world.`;

export const ABOUT_TEXT = `I am a skilled web developer with proficiency in React, HTML, CSS, Tailwind, and JavaScript, and I have a strong foundation in C++ and Data Structures & Algorithms (DSA). My passion lies in building dynamic, responsive web applications that deliver exceptional user experiences. I focus on optimizing performance and writing clean, maintainable code. With a deep interest in problem-solving, I enjoy tackling complex algorithmic challenges and continuously strive to improve my skills in both frontend development and algorithmic thinking. My goal is to stay at the forefront of the rapidly evolving tech world and leverage my expertise to create innovative solutions.`;

export const EXPERIENCES = [
  {
    year: "2023 - Present",
    role: "Software Developer Intern",
    company: "TurnPikeAnalyst LLC.",
    description: `Worked as a trainee, learn and worked on Javascript,React`,
    technologies: ["Javascript", "React.js", "SQL", "Marketing"],
  },
];

export const PROJECTS = [
  {
    title: "CTF website",
    link : "https://github.com/Arijit-017/CTF",
    image: project1,
    description:
      "Developed a responsive CTF competition website for ISTE-HIT's ExploitX event with user authentication and a real-time leaderboard using React and Firebase.",
    technologies: ["React", "TailwindCSS", "Firebase"],
  },
  {
    title: "ISTE Hactoberfest",
    link : "https://github.com/Arijit-017/ISTE-Contribution-React",
    image: project1,
    description:
      "This is a website to get contributions from students to know how to contribute in hactoberfest.",
    technologies: ["HTML", "CSS", "React"],
  },
  {
    title: "Tic Tac Toe",
    link : "https://github.com/Arijit-017/Tic-Tac-Toe",
    image: project2,
    description:
      "This is a website to get contributions from students to know how to contribute in hactoberfest.",
    technologies: ["HTML", "CSS", "Javascript"],
  },
];

export const CONTACT = {
  address: "Naihati, North 24 Parganas, West Bengal, India",
  phoneNo: "+91 7439572369",
  email: "arijit017@gmail.com",
};
